import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { Toolbar } from "./Toolbar";
import { type ToolbarDataProps, toolbarDataSchema } from "./Toolbar.schema";
import { TOOLBAR_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [TOOLBAR_TAG_NAME]: { props: ToolbarDataProps; handle: undefined };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-toolbar": HTMLElement;
  }
}

function RWCToolbar({
  divider,
  align,
  wrap,
  size,
}: ToolbarDataProps): JSX.Element {
  return (
    <Toolbar divider={divider} align={align} wrap={wrap} size={size}>
      <slot />
    </Toolbar>
  );
}

componentManager.register(
  rwc(TOOLBAR_TAG_NAME, {
    component: RWCToolbar,
    dataSchema: toolbarDataSchema,
    usesSlots: true,
  }),
);
